var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['left-side-page', _vm.isOpen  ? 'left-side-page--moved' : '']},[_c('div',{staticClass:"left-side-spacer"}),_c('Categories',{class:['side-category', _vm.isOpen  ? 'side-category--moved' : '']})],1)}
var staticRenderFns = []

export { render, staticRenderFns }